/**
 * Brazilian Bank Code Mappings
 * Maps bank codes (used in file paths) to bank names
 */

export const BANK_CODE_MAPPINGS: Record<string, string> = {
  // Major Brazilian Banks
  '001': 'Banco do Brasil',
  '033': 'Banco Santander',
  '104': 'Caixa Econômica Federal',
  '237': 'Bradesco',
  '341': 'Itaú',
  '260': 'Nubank',
  '077': 'Inter',
  '336': 'C6 Bank',
  '212': 'Banco Original',
  '696': 'PicPay',
  '456': 'Banco Neon',
  '208': 'BTG Pactual',

  // Other Common Banks
  '004': 'Banco Noroeste',
  '021': 'Banco do Estado do Rio Grande do Sul',
  '025': 'Banco Alfa',
  '036': 'Banco Bradesco BBI',
  '037': 'Banco do Estado do Pará',
  '041': 'Banco do Estado do Rio de Janeiro',
  '047': 'Banco do Estado de Sergipe',
  '048': 'Banco do Estado da Bahia',
  '070': 'Banco de Brasília',
  '085': 'Banco Original',
  '093': 'Bando da Amazônia',
  '102': 'XP Investimentos',
  '105': 'Lecca',
  '107': 'Banco Bonsucesso',
  '109': 'Banco Credibel',
  '116': 'Banco NetBank',
  '121': 'Banco Agibank',
  '122': 'Banco Bradesco',
  '124': 'Banco Woori',
  '125': 'Banco Plural',
  '127': 'Banco BVA',
  '133': 'Banco RNX',
  '151': 'Banco Nossa Caixa',
  '157': 'Banco Dasa',
  '159': 'Banco Fator',
  '174': 'Banco Pecunia',
  '180': 'Banco BMG',
  '183': 'Banco Socred',
  '184': 'Banco BNP Paribas',
  '188': 'Banco Safra',
  '189': 'Banco HSBC',
  '191': 'Banco Pactual',
  '194': 'Banco Parana',
  '197': 'Banco Stone',
  '200': 'Banco AXIAL',
  '204': 'Banco Triângulo',
  '205': 'Banco Alvorada',
  '206': 'Banco FIC',
  '210': 'Banco Citi',
  '211': 'Banco SUDAMERIS',
  '213': 'Banco Arbi',
  '214': 'Banco Dibens',
  '215': 'Banco American Bank',
  '217': 'Banco John Deere',
  '218': 'Banco Bonsucesso',
  '222': 'Banco Credit Agricole',
  '224': 'Banco Fibra',
  '225': 'Banco Brascan',
  '228': 'Banco Índigo',
  '229': 'Banco RCI',
  '230': 'Banco BPN',
  '231': 'Banco Dama',
  '233': 'Banco GE',
  '234': 'Banco Laranja',
  '236': 'Banco C6',
  '241': 'Banco Bari',
  '242': 'Banco Luso',
  '243': 'Banco Maxima',
  '244': 'Banco Pottencial',
  '245': 'Banco Opportunity',
  '246': 'Banco ABC Brasil',
  '247': 'Banco Cooperativo do Brasil',
  '249': 'Banco Investcred',
  '250': 'Banco Schahin',
  '251': 'Banco Cora',
  '253': 'Banco Cifra',
  '254': 'Banco Paraná',
  '258': 'Banco Indusval',
  '263': 'Banco Cacique',
  '265': 'Banco Fator',
  '266': 'Banco Cédula',
  '278': 'Banco Genial',
  '286': 'Banco Inter',
  '290': 'Banco PagSeguro',
  '291': 'Banco De Lage',
  '300': 'Banco La Nación',
  '311': 'Banco C2',
  '318': 'Banco BMG',
  '320': 'Banco C&J',
  '323': 'Banco Pan',
  '330': 'Banco Rendimento',
  '346': 'Banco Cetelem',
  '347': 'Banco Sofisa',
  '349': 'Banco XP',
  '351': 'Banco Neon',
  '353': 'Banco BS2',
  '356': 'Banco Real',
  '366': 'Banco Société Générale',
  '370': 'Banco Western Union',
  '376': 'Banco J.P. Morgan',
  '389': 'Banco Mercantil do Brasil',
  '394': 'Banco XP',
  '399': 'Banco HSBC',
  '412': 'Banco Capital',
  '422': 'Banco Safra',
  '424': 'Banco Noroeste',
  '434': 'Banco SOROCRED',
  '453': 'Banco Rural',
  '464': 'Banco Sumitomo',
  '477': 'Banco Citibank',
  '479': 'Banco Itaú',
  '480': 'Banco Monteiro',
  '488': 'Banco Mirante',
  '489': 'Banco Banif',
  '492': 'Banco ING',
  '493': 'Banco WestLB',
  '494': 'Banco La República',
  '495': 'Banco La Provincia',
  '496': 'Banco Exel',
  '497': 'Banco Cofidis',
  '498': 'Banco WestLB',
  '499': 'Banco Hipotecário',
  '504': 'Banco BGN',
  '505': 'Banco Credibel',
  '512': 'Banco Cisa',
  '513': 'Banco BVA',
  '515': 'Banco Hipotecário',
  '518': 'Banco Triângulo',
  '520': 'Banco Cacique',
  '521': 'Banco Cacique',
  '522': 'Banco Cacique',
  '523': 'Banco Cacique',
  '525': 'Banco Cacique',
  '526': 'Banco Cacique',
  '527': 'Banco Cacique',
  '528': 'Banco Cacique',
  '529': 'Banco Cacique',
  '530': 'Banco Cacique',
  '531': 'Banco Cacique',
  '532': 'Banco Cacique',
  '533': 'Banco Cacique',
  '534': 'Banco Cacique',
  '535': 'Banco Cacique',
  '536': 'Banco Cacique',
  '537': 'Banco Cacique',
  '538': 'Banco Cacique',
  '539': 'Banco Cacique',
  '540': 'Banco Cacique',
  '541': 'Banco Cacique',
  '542': 'Banco Cacique',
  '543': 'Banco Cacique',
  '544': 'Banco Cacique',
  '545': 'Banco Cacique',
  '546': 'Banco Cacique',
  '547': 'Banco Cacique',
  '548': 'Banco Cacique',
  '549': 'Banco Cacique',
  '550': 'Banco Cacique',
  '551': 'Banco Cacique',
  '552': 'Banco Cacique',
  '553': 'Banco Cacique',
  '554': 'Banco Cacique',
  '555': 'Banco Cacique',
  '556': 'Banco Cacique',
  '557': 'Banco Cacique',
  '558': 'Banco Cacique',
  '559': 'Banco Cacique',
  '560': 'Banco Cacique',
  '561': 'Banco Cacique',
  '562': 'Banco Cacique',
  '563': 'Banco Cacique',
  '564': 'Banco Cacique',
  '565': 'Banco Cacique',
  '566': 'Banco Cacique',
  '567': 'Banco Cacique',
  '568': 'Banco Cacique',
  '569': 'Banco Cacique',
  '570': 'Banco Cacique',
  '571': 'Banco Cacique',
  '572': 'Banco Cacique',
  '573': 'Banco Cacique',
  '574': 'Banco Cacique',
  '575': 'Banco Cacique',
  '576': 'Banco Cacique',
  '577': 'Banco Cacique',
  '578': 'Banco Cacique',
  '579': 'Banco Cacique',
  '580': 'Banco Cacique',
  '581': 'Banco Cacique',
  '582': 'Banco Cacique',
  '583': 'Banco Cacique',
  '584': 'Banco Cacique',
  '585': 'Banco Cacique',
  '586': 'Banco Cacique',
  '587': 'Banco Cacique',
  '588': 'Banco Cacique',
  '589': 'Banco Cacique',
  '590': 'Banco Cacique',
  '591': 'Banco Cacique',
  '592': 'Banco Cacique',
  '593': 'Banco Cacique',
  '594': 'Banco Cacique',
  '595': 'Banco Cacique',
  '596': 'Banco Cacique',
  '597': 'Banco Cacique',
  '598': 'Banco Cacique',
  '599': 'Banco Cacique',
  '600': 'Banco Cacique',
  '601': 'Banco Cacique',
  '602': 'Banco Cacique',
  '603': 'Banco Cacique',
  '604': 'Banco Cacique',
  '605': 'Banco Cacique',
  '606': 'Banco Cacique',
  '607': 'Banco Cacique',
  '608': 'Banco Cacique',
  '609': 'Banco Cacique',
  '610': 'Banco Cacique',
  '611': 'Banco Cacique',
  '612': 'Banco Cacique',
  '613': 'Banco Cacique',
  '614': 'Banco Cacique',
  '615': 'Banco Cacique',
  '616': 'Banco Cacique',
  '617': 'Banco Cacique',
  '618': 'Banco Cacique',
  '619': 'Banco Cacique',
  '620': 'Banco Cacique',
  '621': 'Banco Cacique',
  '622': 'Banco Cacique',
  '623': 'Banco Cacique',
  '624': 'Banco Cacique',
  '625': 'Banco Cacique',
  '626': 'Banco Cacique',
  '627': 'Banco Cacique',
  '628': 'Banco Cacique',
  '629': 'Banco Cacique',
  '630': 'Banco Cacique',
  '631': 'Banco Cacique',
  '632': 'Banco Cacique',
  '633': 'Banco Cacique',
  '634': 'Banco Cacique',
  '635': 'Banco Cacique',
  '636': 'Banco Cacique',
  '637': 'Banco Cacique',
  '638': 'Banco Cacique',
  '639': 'Banco Cacique',
  '640': 'Banco Cacique',
  '641': 'Banco Cacique',
  '642': 'Banco Cacique',
  '643': 'Banco Cacique',
  '644': 'Banco Cacique',
  '645': 'Banco Cacique',
  '646': 'Banco Cacique',
  '647': 'Banco Cacique',
  '648': 'Banco Cacique',
  '649': 'Banco Cacique',
  '650': 'Banco Cacique',
  '651': 'Banco Cacique',
  '652': 'Banco Cacique',
  '653': 'Banco Cacique',
  '654': 'Banco Cacique',
  '655': 'Banco Cacique',
  '656': 'Banco Cacique',
  '657': 'Banco Cacique',
  '658': 'Banco Cacique',
  '659': 'Banco Cacique',
  '660': 'Banco Cacique',
  '661': 'Banco Cacique',
  '662': 'Banco Cacique',
  '663': 'Banco Cacique',
  '664': 'Banco Cacique',
  '665': 'Banco Cacique',
  '666': 'Banco Cacique',
  '667': 'Banco Cacique',
  '668': 'Banco Cacique',
  '669': 'Banco Cacique',
  '670': 'Banco Cacique',
  '671': 'Banco Cacique',
  '672': 'Banco Cacique',
  '673': 'Banco Cacique',
  '674': 'Banco Cacique',
  '675': 'Banco Cacique',
  '676': 'Banco Cacique',
  '677': 'Banco Cacique',
  '678': 'Banco Cacique',
  '679': 'Banco Cacique',
  '680': 'Banco Cacique',
  '681': 'Banco Cacique',
  '682': 'Banco Cacique',
  '683': 'Banco Cacique',
  '684': 'Banco Cacique',
  '685': 'Banco Cacique',
  '686': 'Banco Cacique',
  '687': 'Banco Cacique',
  '688': 'Banco Cacique',
  '689': 'Banco Cacique',
  '690': 'Banco Cacique',
  '691': 'Banco Cacique',
  '692': 'Banco Cacique',
  '693': 'Banco Cacique',
  '694': 'Banco Cacique',
  '695': 'Banco Cacique',
  '697': 'Banco Cacique',
  '698': 'Banco Cacique',
  '699': 'Banco Cacique',
  '700': 'Banco Cacique',
  '701': 'Banco Cacique',
  '702': 'Banco Cacique',
  '703': 'Banco Cacique',
  '704': 'Banco Cacique',
  '705': 'Banco Cacique',
  '706': 'Banco Cacique',
  '707': 'Banco Cacique',
  '708': 'Banco Cacique',
  '709': 'Banco Cacique',
  '710': 'Banco Cacique',
  '711': 'Banco Cacique',
  '712': 'Banco Cacique',
  '713': 'Banco Cacique',
  '714': 'Banco Cacique',
  '715': 'Banco Cacique',
  '716': 'Banco Cacique',
  '717': 'Banco Cacique',
  '718': 'Banco Cacique',
  '719': 'Banco Cacique',
  '720': 'Banco Cacique',
  '721': 'Banco Cacique',
  '722': 'Banco Cacique',
  '723': 'Banco Cacique',
  '724': 'Banco Cacique',
  '725': 'Banco Cacique',
  '726': 'Banco Cacique',
  '727': 'Banco Cacique',
  '728': 'Banco Cacique',
  '729': 'Banco Cacique',
  '730': 'Banco Cacique',
  '731': 'Banco Cacique',
  '732': 'Banco Cacique',
  '733': 'Banco Cacique',
  '734': 'Banco Cacique',
  '735': 'Banco Cacique',
  '736': 'Banco Cacique',
  '737': 'Banco Cacique',
  '738': 'Banco Cacique',
  '739': 'Banco Cacique',
  '740': 'Banco Cacique',
  '741': 'Banco Cacique',
  '742': 'Banco Cacique',
  '743': 'Banco Cacique',
  '744': 'Banco Cacique',
  '745': 'Banco Cacique',
  '746': 'Banco Cacique',
  '747': 'Banco Cacique',
  '748': 'Banco Cacique',
  '749': 'Banco Cacique',
  '750': 'Banco Cacique',
  '751': 'Banco Cacique',
  '752': 'Banco Cacique',
  '753': 'Banco Cacique',
  '754': 'Banco Cacique',
  '755': 'Banco Cacique',
  '756': 'Banco Cacique',
  '757': 'Banco Cacique',
  '758': 'Banco Cacique',
  '759': 'Banco Cacique',
  '760': 'Banco Cacique',
  '761': 'Banco Cacique',
  '762': 'Banco Cacique',
  '763': 'Banco Cacique',
  '764': 'Banco Cacique',
  '765': 'Banco Cacique',
  '766': 'Banco Cacique',
  '767': 'Banco Cacique',
  '768': 'Banco Cacique',
  '769': 'Banco Cacique',
  '770': 'Banco Cacique',
  '771': 'Banco Cacique',
  '772': 'Banco Cacique',
  '773': 'Banco Cacique',
  '774': 'Banco Cacique',
  '775': 'Banco Cacique',
  '776': 'Banco Cacique',
  '777': 'Banco Cacique',
  '778': 'Banco Cacique',
  '779': 'Banco Cacique',
  '780': 'Banco Cacique',
  '781': 'Banco Cacique',
  '782': 'Banco Cacique',
  '783': 'Banco Cacique',
  '784': 'Banco Cacique',
  '785': 'Banco Cacique',
  '786': 'Banco Cacique',
  '787': 'Banco Cacique',
  '788': 'Banco Cacique',
  '789': 'Banco Cacique',
  '790': 'Banco Cacique',
  '791': 'Banco Cacique',
  '792': 'Banco Cacique',
  '793': 'Banco Cacique',
  '794': 'Banco Cacique',
  '795': 'Banco Cacique',
  '796': 'Banco Cacique',
  '797': 'Banco Cacique',
  '798': 'Banco Cacique',
  '799': 'Banco Cacique'
};

/**
 * Reverse mapping: bank name to code
 */
export const BANK_NAME_TO_CODE: Record<string, string> = {};

// Build reverse mapping
Object.entries(BANK_CODE_MAPPINGS).forEach(([code, name]) => {
  BANK_NAME_TO_CODE[name] = code;
});

/**
 * Get bank name by code
 */
export function getBankNameByCode(code: string): string {
  return BANK_CODE_MAPPINGS[code] || `Banco ${code}`;
}

/**
 * Get bank code by name
 */
export function getBankCodeByName(name: string): string {
  return BANK_NAME_TO_CODE[name] || '';
}

/**
 * Check if code is a valid Brazilian bank code
 */
export function isValidBankCode(code: string): boolean {
  return code in BANK_CODE_MAPPINGS;
}

/**
 * Get bank logo path by code
 */
export function getBankLogoPathByCode(code: string): string {
  return `/logos/banks/${code}.png`;
}